<div class="rbac-page">
  <div class="rbac-page__header">
    <h4>Modules</h4>
    <button type="button" class="rbac-btn rbac-btn--primary" (click)="openAdd()">+ Add Module</button>
  </div>

  <app-rbac-table
    [columns]="columns"
    [rows]="modules"
    [loading]="loading"
    emptyMessage="No modules created yet."
    (edit)="openEdit($event)"
    (delete)="onDelete($event)"
    (toggleStatus)="onToggleStatus($event)"
    (rowSelect)="manageSubModules.emit($event)">
  </app-rbac-table>
  <p class="rbac-page__hint">Click a row to manage its sub-modules.</p>
</div>

<app-rbac-modal [open]="modalOpen" (closed)="closeModal()">
  <app-rbac-form
    [title]="editingModule ? 'Edit Module' : 'Add Module'"
    [fields]="fields"
    [model]="editingModule"
    [saving]="saving"
    (save)="onSave($event)"
    (cancel)="closeModal()">
  </app-rbac-form>
</app-rbac-modal>
